export const getPipelineFilterLocalStorageKey = (userUid: string) =>
  `pipeline-user:${userUid}`;

export const pipelineFilterFormExpandedStorageKey = 'pipeline-filters-expanded';
